module.exports = __webpack_public_path__ + "static/null.687a3d15.png";